export const APP_STORE_APP_ID = '6754633435';

export const APP_STORE_URL = `https://apps.apple.com/cz/app/monery-portfolio-tracker/id${APP_STORE_APP_ID}?l=cs`;
